var Transform = class {
    constructor(wrapper){
        this._createElements(wrapper);
        this.getArea();
        this._addEvents();
    }

    _createElements (wrapper){
        this.box=wrapper;
        this.parentBox=this.box.parentNode;
        this.parent={};
        this.parent.width=this.parentBox.clientWidth;
        this.parent.height=this.parentBox.clientHeight;
        this.isResize=false;
        this.names={}; //имена функций для запуска, курсоров
        this.names.cursor='default';
        this.names.funcBefore;
        this.names.funcTransform;
        this.boxComputedStyle = window.getComputedStyle ? getComputedStyle(this.box, '') : this.box.currentStyle;
        this.area={};
        this.area.marginLeft=parseFloat(this.boxComputedStyle.marginLeft);//справа, снизу нужно предусмотреть
        this.area.marginTop=parseFloat(this.boxComputedStyle.marginTop);
        this.area.border=parseFloat(this.boxComputedStyle.borderLeftWidth); // границы одинаковые со всех сторон, другое нужно предусматривать
        this.area.minSize=5;
        this.area.maxSize;//вычисляем для каждого направления отдельно
        this.area.getOffsetSize;//ф-я задается для каждого направления отдельно
        this.area.minLeft=-this.area.marginLeft;
        this.area.maxLeft;
        this.area.minTop=-this.area.marginTop;
        this.area.maxTop;
    }

    reset(){
        this.box.style.cssText='';
    }

    getArea(){
        this.area.parentWidth=this.parentBox.clientWidth;
        this.area.parentHeight=this.parentBox.clientHeight;
        this.area.width=this.box.clientWidth;
        this.area.height=this.box.clientHeight;
        this.area.offsetLeft=this.box.offsetLeft;
        this.area.offsetRight=this.area.parentWidth-this.area.offsetLeft-this.area.width-this.area.border*2;
        this.area.offsetTop=this.box.offsetTop;
        this.area.offsetBottom=this.area.parentHeight-this.area.offsetTop-this.area.height-this.area.border*2;
    }

    _addEvents(){
        var self=this;

        this.eNames = {}
        if (window.navigator.pointerEnabled) this.eNames = {'down': 'pointerdown', 'move': 'pointermove', 'enter':'pointerenter', 'leave':'pointerleave', 'up': 'pointerup'};
        else if(window.navigator.msPointerEnabled) this.eNames = {'down': 'MSPointerDown', 'move': 'MSPointerMove', 'enter':'MSPointerEnter', 'leave':'MSPointerLeave', 'up': 'MSPointerUp'};
        else if('ontouchstart' in document.documentElement) {
            this.eNames = {'down': 'touchstart', 'move': 'touchmove', 'enter':'touchstart', 'leave':'touchend', 'up': 'touchend'};
        }
        else this.eNames = {'down': 'mousedown', 'move': 'mousemove', 'enter':'mouseenter', 'leave':'mouseleave', 'up': 'mouseup'};

        if (document.body.addEventListener){var addEvent='addEventListener', on='';}
        else {var addEvent='attachEvent', on='on';}

        this.box['on'+this.eNames.move]=function(e){
            e = e || window.event;
            e = e.touches ? e.touches[0] : e;

            if (!self.isResize) self._defineCursor.call(self, e);
        }

        document.body[addEvent](on+this.eNames.down, function(e){
            e=e || window.event;
            e = e.touches ? e.touches[0] : e;

            var target = e.target || e.srcElement;
            if(target==self.box){
                self.getArea();
                self.area.x=e.clientX;
                self.area.y = e.clientY;
                self.isResize=true;
                document.body.style.cursor=self.names.cursor;
                self[self.names.funcBefore].call(self, e);
            }
        }, false);

        document.body[addEvent](on+this.eNames.move, function(e){
            e=e || window.event;
            e = e.touches ? e.touches[0] : e;

            if (self.isResize) self[self.names.funcTransform].call(self, e);
        }, false);

        document.body[addEvent](on+this.eNames.up, function(e){
            if (self.isResize) {
                document.body.style.cursor='default';
                self.isResize=false;
            }
        }, false);
    }

    _resize(e){
        var offset=this.area.getOffsetSize(e.clientX, e.clientY);
        this.box.style.width=Math.max(Math.min((this.area.width+offset), this.area.maxSize), this.area.minSize) + 'px';
        this.box.style.height=this.box.style.width;
    }

    _move(e){//Объединить с ресайз?
        this.box.style.left=Math.max(Math.min(this.area.offsetLeft-this.area.marginLeft+e.clientX-this.area.x, this.area.maxLeft), this.area.minLeft) + 'px';
        this.box.style.top=Math.max(Math.min(this.area.offsetTop-this.area.marginTop+e.clientY-this.area.y, this.area.maxTop), this.area.minTop) + 'px';
    }

    _nwBeforeResize(e){
        this.area.getOffsetSize=function(x, y){return (this.x-x-y+this.y)/2};
        this.box.style.left='auto';
        this.box.style.right=this.area.offsetRight+'px';
        this.box.style.top='auto';
        this.box.style.bottom=this.area.offsetBottom+'px';
        this.area.maxSize=Math.min((this.area.parentWidth-this.area.offsetRight), (this.area.parentHeight-this.area.offsetBottom)) - this.area.border*2;//выбираем меньшее из макс высоты и ширины
    }

    _swBeforeResize(e){
        this.area.getOffsetSize=function(x, y){return (this.x-x+y-this.y)/2};
        this.box.style.left='auto';
        this.box.style.right=this.area.offsetRight+'px';
        this.box.style.top=this.area.offsetTop-this.area.marginTop+'px';
        this.box.style.bottom='auto';
        this.area.maxSize=Math.min((this.area.parentWidth-this.area.offsetRight), (this.area.parentHeight-this.area.offsetTop)) - this.area.border*2;//выбираем меньшее из макс высоты и ширины
    }

    _neBeforeResize(e){
        this.area.getOffsetSize=function(x, y){return (x-this.x-y+this.y)/2};
        this.box.style.left=this.area.offsetLeft-this.area.marginLeft+'px';
        this.box.style.right='auto';
        this.box.style.top='auto';
        this.box.style.bottom=this.area.offsetBottom+'px';
        this.area.maxSize=Math.min((this.area.parentWidth-this.area.offsetLeft), (this.area.parentHeight-this.area.offsetBottom)) - this.area.border*2;//выбираем меньшее из макс высоты и ширины
    }

    _seBeforeResize(e){
        this.area.getOffsetSize=function(x, y){return (x-this.x+y-this.y)/2};
        this.box.style.left=this.area.offsetLeft-this.area.marginLeft+'px';
        this.box.style.right='auto';
        this.box.style.top=this.area.offsetTop-this.area.marginTop+'px';
        this.box.style.bottom='auto';
        this.area.maxSize=Math.min((this.area.parentWidth-this.area.offsetLeft), (this.area.parentHeight-this.area.offsetTop)) - this.area.border*2;//выбираем меньшее из макс высоты и ширины
    }

    _beforeMove (e){
        this.box.style.left=this.area.offsetLeft-this.area.marginLeft+'px';
        this.box.style.right='auto';
        this.box.style.top=this.area.offsetTop-this.area.marginTop+'px';
        this.box.style.bottom='auto';
        this.area.maxLeft=this.area.parentWidth-this.area.width-this.area.marginLeft-this.area.border*2;
        this.area.maxTop=this.area.parentHeight-this.area.height-this.area.marginTop-this.area.border*2;
    }

    _defineCursor (e){

        var x = e.offsetX==undefined?e.layerX:e.offsetX;
        var y = e.offsetY==undefined?e.layerY:e.offsetY;
        var offsetX=x/(this.box.clientWidth+this.area.border*2);
        var offsetY=y/(this.box.clientWidth+this.area.border*2);

        if(offsetX<.3){
            if(offsetY<.5){
                this.names.cursor='nw-resize';
                this.names.funcBefore='_nwBeforeResize';
                this.names.funcTransform='_resize';
            }
            else{
                this.names.cursor='sw-resize';
                this.names.funcBefore='_swBeforeResize';
                this.names.funcTransform='_resize';
            }
        }
        else if (offsetX>.7) {
            if(offsetY<.5){
                this.names.cursor='ne-resize';
                this.names.funcBefore='_neBeforeResize';
                this.names.funcTransform='_resize';
            }
            else{
                this.names.cursor='se-resize';
                this.names.funcBefore='_seBeforeResize';
                this.names.funcTransform='_resize';
            }
        }
        else {
            this.names.cursor = 'move';
            this.names.funcBefore='_beforeMove';
            this.names.funcTransform='_move';
        }
        this.box.style.cursor=this.names.cursor;
    }
};

export {Transform};




